export default {
  title: 'Pozycje',
};
